<template>
  <div class="dialog-wrap">
    <el-dialog title="帮助中心"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="980px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="80px">
        <el-form-item label="标题"
                      prop="title">
          <el-input v-model="dataForm.title"
                    placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="分类"
                      prop="category_ids">
          <el-select v-model="dataForm.category_ids"
                     clearable
                     placeholder="请选择">
            <el-option label="调剂流程指导"
                       :value="21">
            </el-option>
            <el-option label="关于调剂信息"
                       :value="22">
            </el-option>
            <el-option label="关于调剂分析"
                       :value="23">
            </el-option>
            <el-option label="关于调剂推荐"
                       :value="24">
            </el-option>
            <el-option label="关于个人中心"
                       :value="25">
            </el-option>
            <el-option label="其他热门问题"
                       :value="26">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频上传"
                      prop="file_type">
          <el-select v-model="dataForm.file_type"
                     clearable
                     placeholder="请选择">
            <el-option label="百度编辑器上传"
                       :value="1">
            </el-option>
            <el-option label="OSS上传"
                       :value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <div style="marginLeft:80px;marginBottom:15px"
             v-if="dataForm.file_type=='2'">
          <input @change="upload"
                 type="file"
                 name="photoImg"
                 id="getFile"
                 class="upload-input" />
        </div>

        <el-form-item label="排序值"
                      prop="sort">
          <el-input v-model="dataForm.sort"
                    placeholder="请输入排序值"></el-input>
        </el-form-item>
        <el-form-item label="内容"
                      prop="content">
          <UEeditor :setDataStr="dataForm.content"
                    @change="initDtaForm" />
        </el-form-item>

      </el-form>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { helpArticleedit, helpArticleOne } from '@/api/distribution'
import UEeditor from '@/components/UEeditor.vue'
import { fileUploadvideo } from '@/api/index'
export default {
  components: {
    UEeditor,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        force_delete_type: 2,
        file_type: 1,
      },
      rules: {
        /*  product_name: [{ required: true, message: '请选择商品', trigger: 'foucs' }], */
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        category_ids: [
          { required: true, message: '请选择分类', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      helpArticleOne({ id: val.id }).then((res) => {
        this.dataForm = res
        this.dataForm.category_ids = Number(res.category_ids)
      })
    },
  },
  methods: {
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        /******  此处为上传服务器 start   ******/
        let content = new FormData()
        content.append('file', file)
        fileUploadvideo(content).then((res) => {
          this.dataForm.content = this.dataForm.content
            ? +this.dataForm.content + res.url
            : res.url
          if (res == null) {
            this.$message.success(`导入成功`)
          }
        })
      }
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm)
          helpArticleedit(params)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.dataForm = { force_delete_type: 2 }
      this.$emit('close')
    },
    initDtaForm(e) {
      this.dataForm.content = e
    },
  },
}
</script>

<style lang="less" scoped>
.tips {
  margin-top: 16px;
  text-align: center;
  font-size: 12px;
  color: #999999;
}
</style>
